import { render, staticRenderFns } from "./ChatBusinessCard.vue?vue&type=template&id=5844ab6b&scoped=true"
import script from "./ChatBusinessCard.vue?vue&type=script&lang=js"
export * from "./ChatBusinessCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5844ab6b",
  null
  
)

export default component.exports